<template>
  <div>
    <router-view />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCompanyStore } from '@/stores'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

const { locale } = useI18n()
const companyStore = useCompanyStore()

onMounted(async () => {
  // Carrega idioma salvo
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale) {
    locale.value = savedLocale
  }
  
  // Detecta hostname e carrega empresa (somente para rotas públicas)
  const currentPath = window.location.pathname
  const isAdminRoute = currentPath.startsWith('/admin') || currentPath.startsWith('/login') || currentPath.startsWith('/superadmin')
  if (!isAdminRoute) {
    const hostname = companyStore.detectCompanyByHostname()
    if (hostname) {
      await companyStore.fetchByHostname(hostname)
    }
  }
})
</script>
